import React from "react";

type Variant = "primary" | "secondary" | "danger" | "success" | "warning" | "ghost";
type Size    = "sm" | "md" | "lg";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  children: React.ReactNode;
  fullWidth?: boolean;
}

const VARIANTS: Record<Variant, string> = {
  primary:   "bg-indigo-600 hover:bg-indigo-700   text-white  border-indigo-500/30 shadow-sm",
  secondary: "bg-white/60  hover:bg-white/80       text-gray-700 border-gray-300/50",
  danger:    "bg-red-500   hover:bg-red-600        text-white  border-red-400/30   shadow-sm",
  success:   "bg-emerald-500 hover:bg-emerald-600  text-white  border-emerald-400/30 shadow-sm",
  warning:   "bg-amber-500 hover:bg-amber-600      text-white  border-amber-400/30  shadow-sm",
  ghost:     "bg-transparent hover:bg-white/40     text-gray-700 border-transparent",
};
const SIZES: Record<Size, string> = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2   text-sm",
  lg: "px-6 py-3   text-base",
};

const Button: React.FC<Props> = ({
  variant = "primary", size = "md", children, fullWidth, className = "", disabled, ...rest
}) => (
  <button
    disabled={disabled}
    className={`inline-flex items-center gap-2 rounded-xl font-semibold border transition-all duration-200
      ${VARIANTS[variant]} ${SIZES[size]}
      ${fullWidth ? "w-full justify-center" : ""}
      ${disabled ? "opacity-50 cursor-not-allowed" : ""}
      ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export default Button;
